/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Flex, Text } from '@chakra-ui/react'
import { FaMapMarkerAlt, FaPaperPlane, FaCheck, FaClipboardList } from 'react-icons/fa'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { iCardPesquisa } from '../../../../../interfaces'
import { PropInvalida } from '../../../../../Utils/Helper'
import { ColumnText, PreViewParticipante, GridContainer } from './styles'

interface CardProps {
  pesquisa: iCardPesquisa
  onSelect: (id: string) => void
}

export const CardPesquisa: React.FC<CardProps> = ({ pesquisa, onSelect }) => {
  function ObterCorStatus(): string {
    if (pesquisa.statusDaPesquisa === 0 || pesquisa.statusDaPesquisa === 3) return 'var(--Yellow)'
    if (pesquisa.statusDaPesquisa === 1) return 'var(--Red)'
    if (pesquisa.statusDaPesquisa === 2) return 'var(--Green3)'

    return 'none'
  }

  function ReturnInfoEnvioBox(): any {
    const info = pesquisa.envioInfo
    if (info?.status === 0) {
      return (
              <ColumnText>
                  <Text fontSize={'.875rem'}>{info.mensagem.split(': ')[0]}:</Text>
                  <Text fontSize={'.875rem'} fontWeight={'700'} mt={'-.25rem'}>{info.mensagem.split(': ')[1]}</Text>
              </ColumnText>
      )
    } else if (info?.status === 1) {
      return (
              <ColumnText style={{ wordBreak: 'break-word', width: '8.5rem', fontSize: '.875rem', lineHeight: '.875rem' }}>{info.mensagem}</ColumnText>
      )
    } else if (info?.status === 2) {
      return (
              <ColumnText style={{ wordBreak: 'break-word', width: '8.5rem', fontSize: '.875rem', lineHeight: '.875rem' }}>{info.mensagem}</ColumnText>
      )
    } else if (info?.status === 3) {
      return (
              <ColumnText style={{ wordBreak: 'break-word', width: '8.5rem', fontSize: '.875rem', lineHeight: '.875rem' }}>{info.mensagem}</ColumnText>
      )
    } else if (info?.status === 4) {
      return (
              <ColumnText style={{ wordBreak: 'break-word', width: '8.5rem', fontSize: '.875rem', lineHeight: '.875rem' }}>{info.mensagem}</ColumnText>
      )
    }
  }

  return (
        <PreViewParticipante color={ObterCorStatus()}>
            <Box w={'.3rem'} h={'.3rem'} bg={ObterCorStatus()} borderRadius={'50%'} pos={'absolute'} top={'10px'} left={'10px'}></Box>
            <GridContainer>
                <ColumnText>
                    <h4><strong>{pesquisa.nomePesquisa}</strong></h4>
                    {
                        (pesquisa.competenciasDoPdi) && (
                            <Flex alignItems={'center'} gap='.325rem' mt='.325rem'>
                                <FaCheck color='var(--Green2)' size={14}/>
                                <h4 style={{ color: 'var(--Green2)', fontSize: '.813rem', lineHeight: '.813rem' }}>Competências trabalhadas no ultimo PDI</h4>
                            </Flex>
                        )
                    }
                </ColumnText>

                {
                    (!PropInvalida(pesquisa.baseCiclo) && pesquisa.baseCiclo?.includes('Data de ingresso do avaliado')) && (
                        <ColumnText>
                            <h4>Base ciclo</h4>
                            <span>{pesquisa.baseCiclo}</span>
                        </ColumnText>
                    )
                }

                {
                    (PropInvalida(pesquisa.baseCiclo)) && (
                        <ColumnText>
                            <h4>Início</h4>
                            <span>{pesquisa.dataInicio !== null ? pesquisa.dataInicio : 'Não definido'}</span>
                        </ColumnText>
                    )
                }

                {
                    (PropInvalida(pesquisa.ciclo) && PropInvalida(pesquisa.baseCiclo)) && (
                        <ColumnText>
                            <h4>Término</h4>
                            <span>{pesquisa.dataFim !== null ? pesquisa.dataFim : 'Não definido'}</span>
                        </ColumnText>
                    )
                }

                {
                    (!PropInvalida(pesquisa.ciclo)) && (
                        <ColumnText>
                            <h4>Ciclo</h4>
                            <span>{pesquisa.ciclo}</span>
                        </ColumnText>
                    )
                }

                <Flex alignItems={'center'}>
                    <FaMapMarkerAlt size={22} style={{ marginRight: '.25rem', color: 'var(--a5)' }} />
                    <ColumnText>
                        <h3>{pesquisa.totalAvaliadores ?? 0}</h3>
                        <h4>Avaliadores</h4>
                    </ColumnText>
                </Flex>

                {
                (!PropInvalida(pesquisa.envioInfo)) && (
                    <Flex alignItems={'center'}>
                        {pesquisa.statusDaPesquisa === 0 && <Flex alignItems={'center'} justifyContent={'center'} w={'26px'} h={'28px'}><FaClipboardList size={26} style={{ marginRight: '.5rem', color: 'var(--a5)' }} /></Flex>}
                        {pesquisa.statusDaPesquisa === 1 && <Flex alignItems={'center'} justifyContent={'center'} w={'26px'} h={'28px'}><FaPaperPlane size={26} style={{ marginRight: '.5rem', color: 'var(--a5)' }} /></Flex>}
                        {pesquisa.statusDaPesquisa === 2 && <Flex alignItems={'center'} justifyContent={'center'} w={'26px'} h={'30px'}><FaCheck size={26} style={{ marginRight: '.5rem', color: 'var(--a5)' }} /></Flex>}
                        {ReturnInfoEnvioBox()}
                    </Flex>
                )
                }
            </GridContainer>
            <Flex alignItems={'center'} marginRight={'1rem'}>
                <ButtonCmp VarColor='Green2' onClick={() => onSelect(pesquisa.id)}>Selecionar</ButtonCmp>
            </Flex>
        </PreViewParticipante>
  )
}
